import React, { useState, useEffect } from "react";
import Paso1 from "./steps/step1";
import Paso2 from "./steps/step2";
import Paso3 from "./steps/step2_5";
import Paso4 from "./steps/step3";
import { Box, Container } from "@mui/material";
import logoSAE from "../../assets/PlanSAE.png";
import HeroHeader from "../HeroHeader";

const LOCALSTORAGE_KEYS_TO_CLEAR = [
  "sac_hash_step3",
  "sac_step2_data",
  "sac_step5_data",
  "sac_temas_generados",
  "seleccionPaso1",
  "seleccionPaso2",
  "seleccionPaso2_key",
  "seleccionPaso3",
  "sesionesPaso3",
  "sesionesPaso3_key",
  "temasPaso3",
  "temasPaso3_key",
  "ultimoMongoId",
];

const AdmSAEForm = () => {
  useEffect(() => {
    LOCALSTORAGE_KEYS_TO_CLEAR.forEach((key) => {
      localStorage.removeItem(key);
    });
  }, []);

  const [paso, setPaso] = useState(1);

  const [selectores, setSelectores] = useState({});
  const [subareas, setSubareas] = useState([]);
  const [temas, setTemas] = useState({});

  const avanzar = () => setPaso((p) => p + 1);
  const retroceder = () => setPaso((p) => p - 1);

  // Usamos useEffect para actualizar subareas y temas de manera controlada
  useEffect(() => {
    // Aquí podemos actualizar subareas y temas, sin que se cause el error de actualización mientras se renderiza
  }, [subareas, temas]);
  const sxPage = { px: { xs: 2, sm: 4, md: 8, lg: 12 } };

  return (
    <Box sx={{ mb: 2 }}>

      <Box
        sx={{
          py: { xs: 3, md: 4 },
          px: { xs: 2, md: 4 },
        }}>

        <HeroHeader
          img={logoSAE}
          subtitle="PLANIFICADOR DE SESIONES"
          title="Planificador de Sesiones SAE"
          description="Diseña y genera sesiones de aprendizaje estructuradas paso a paso, alineadas al currículo y adaptadas al nivel y área seleccionada."
          maxWidth="xxl"
        />
      </Box>

      <Container maxWidth="xxl" sx={sxPage}>

        {paso === 1 && (
          <Paso1
            onNext={avanzar}
            setSelectores={setSelectores}
            initialValues={selectores}
          />
        )}

        {paso === 2 && (
          <Paso2
            onNext={avanzar}
            onBack={retroceder}
            selectores={selectores}
            setSubareas={setSubareas}
            setTemas={setTemas}
          />
        )}

        {paso === 3 && (
          <Paso3
            onNext={avanzar}
            onBack={retroceder}
            selectores={selectores}
            subareas={subareas}
            setSubareas={setSubareas}
            temasPorSubarea={temas}
            setTemas={setTemas}
          />
        )}

        {paso === 4 && (
          <Paso4
            onNext={avanzar}
            onBack={retroceder}
            selectores={selectores}
            subareas={subareas}
            temas={temas}
          />
        )}
      </Container>
    </Box>
  );
};

export default AdmSAEForm;
